var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40926 3.94238H1.16016V17.0004H2.40926V3.94238Z",
    fill: "#EA5554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8409 3.94238H11.5918V17.0004H12.8409V3.94238Z",
    fill: "#EA5554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44833 5.40918H8.19922V14.3269H9.44833V5.40918Z",
    fill: "#EA5554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80184 5.40918H4.55273V14.3269H5.80184V5.40918Z",
    fill: "#EA5554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20407 0H5.80078V2.62101H8.20407V0Z",
    fill: "#EA5554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8398 16.9977V15.6924L1.16319 15.6924V16.9977L12.8398 16.9977Z",
    fill: "#EA5554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.002 2.62169V1.31641L0.00195312 1.31641V2.62169L14.002 2.62169Z",
    fill: "#EA5554"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.5aef26b8fcdca16be8e20a73ec679f2e.svg";
export { ForwardRef as ReactComponent };